import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'frontbucket.jiraTab.emptyState.noRelevantProjects.header',
    description:
      'Header for no relevant projects empty state of the Jira issues tab',
    defaultMessage: `Track your Jira projects from within your Bitbucket repository.`,
  },
  description: {
    id: 'frontbucket.jiraTab.emptyState.noRelevantProjects.description',
    description:
      'Descriptive text for no relevant projects empty state of the Jira issues tab',
    defaultMessage:
      'Create and update your Jira issues. You can also create branches from issues and navigate to connected Jira projects from your repository.',
  },
  linkingOptionsText: {
    id: 'frontbucket.jiraTab.emptyState.noRelevantProjects.linkingOptionsText',
    description:
      'Descriptive text for automatic and manual ways of linking Jira projects to Bitbucket repository',
    defaultMessage:
      'Link a Jira project by including an issue key in any pull request title or commit message.{lineBreak}Alternatively you can {manageProjectsDialogLink}.',
  },
  manageProjectsDialogLinkText: {
    id: 'frontbucket.jiraTab.emptyState.noRelevantProjects.manuallyLinkProjectsText',
    description:
      'Part of another text, a link to open manage projects modal dialog',
    defaultMessage: 'manually link Jira projects',
  },
  issuesListPreviewText: {
    id: 'frontbucket.jiraTab.emptyState.noRelevantProjects.issuesListPreviewText',
    description:
      'Descriptive text for Jira issues functionality when Jira project is linked to the repository',
    defaultMessage:
      'Once a Jira project is linked to this repository, its issues will automatically show up here.',
  },
  learnMoreLinkLabel: {
    id: 'frontbucket.jiraTab.emptyState.noRelevantProjects.learnMoreLinkLabel',
    description:
      'A link to more information about using relevant Jira projects',
    defaultMessage: 'Learn more about integrating Jira with Bitbucket',
  },
});
